import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

interface data {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-ops-transactional-grid',
  templateUrl: './ops-transactional-grid.component.html',
  styleUrls: ['./ops-transactional-grid.component.css']
})
export class OpsTransactionalGridComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  custs: data[] = [
    { value: 'FREEDOM-1', viewValue: 'FREEDOM' },
    { value: 'XOME-2', viewValue: 'XOME' },
    { value: 'PROTECK-3', viewValue: 'PROTECK' },
    { value: 'BK EMPOWER-4', viewValue: 'BK EMPOWER' },
    { value: 'FREEDOM XPANSE-5', viewValue: 'FREEDOM XPANSE' },
  ];

  eveType = new FormControl();
  eveTypesList =
    ['Authorized', 'Setteled', 'Completed', 'Refund', 'Chargeback', 'Paid Out'];
  selectedTypes;

  butNot = new FormControl();
  butNotList =
    ['Authorized', 'Setteled', 'Completed', 'Refund', 'Chargeback', 'Paid Out'];
  selectedList;

  public ShowFilters: boolean = true;
  public buttonName: any = 'Show Filters';

  toggle() {
    this.ShowFilters = !this.ShowFilters;
    if (this.ShowFilters)
      this.buttonName = "Hide Filters";
    else
      this.buttonName = "Show Filters";
  }


}
